<template>
    <j-page class="j-components-layout">
        <div slot="table">
            <component v-for="name in demo" :is="name" :key="name" />
        </div>
    </j-page>
</template>

<script>
    const demoComponents = require.context('@/components/JComponents', true, /demo.vue$/).keys() // 获取所有demo文件

    const importComponent = file => require(`@/components/JComponents${file}.vue`).default // 根据文件路径引入文件

    const components = {}

    demoComponents.forEach((address, index) => {
        const ComponentPath = address.replace(/^\.(.*)\.vue$/,'$1')
        components[`demo${index}`] = importComponent(ComponentPath)
    })

    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    export default {
        name: "JComponents",
        mixins: [PageMixins],
        components,
        data () {
            return {
                demo: Object.keys(components)
            }
        }
    }
</script>

<style lang="scss">
    .j-components-layout {
        position: relative;
        height: 100%;
        .el-card {
            position: relative;
            margin-bottom: 50px;
        }
    }
</style>
